// Glide
import Glide from '@glidejs/glide'

/**
*
* Hero Slider
*
*/
const SureifyHeroSlider = () => {
    let $imageSlider = $('.glide-images')
    if ($imageSlider.length > 0) {
        new Glide('.glide-images', {
            perView : 1,
            gap: 0,
            autoplay: 5000,
        }).mount()
    }
}

/**
*
* Product Images
*
*/
const SureifyProductSlider = () => {
    let $productImages = $('.glide-product-images')
    if ($productImages.length > 0) {
        new Glide('.glide-product-images', {
            rewind: true,
            autoplay: 5000,
            type: 'slider'
        }).mount()
    }
}

/**
*
* Product Options
*
*/
const SureifyProductOptions = () => {

    let productOptions = document.querySelectorAll('.glide-product-options')
    if (productOptions.length > 0) {

        Object.values(productOptions).map(carousel => {

            let $carousel = $(carousel);
            let currentIndex = $carousel.find('a[data-product-variant="active"]').parent().index()
            let glide;

            glide = new Glide(carousel, {
                autoplay: false,
                perView: $carousel.data('per-view') ? $carousel.data('per-view') : 4,
                type: 'carousel',
                gap: 5,
                startAt : currentIndex,
                focusAt: 'center',
                peek: {
                    before: 0,
                    after: 0
                },
                breakpoints: {
                    460: {
                        perView: 3,
                    },
                    768: {
                        perView: 6
                    },
                    1280: {
                        perView: $carousel.data('per-view') ? $carousel.data('per-view') : 4
                    }
                },
            })

            let $control = $carousel.find('[data-glide-dir=">"]')
            let $back = $carousel.find('[data-glide-dir="<"]')
            if ($control.length > 0) {
                $control.on('click', function(event) {
                    event.preventDefault()
                    $back.removeClass('opacity-0 invisible')
                })
            }

            glide.mount()

        });
    }
}

/**
*
* Product Carousel
*
* @params Passed as data attributes via the HTML template.
* @link https://glidejs.com/docs/options/
*/

const SureifyCarousel = (selector) => {

    let productCarousels = document.querySelectorAll(selector);

    if (productCarousels.length > 0) {

        let windowWidth = $(window).width()
        let glide;
        let options;

        Object.values(productCarousels).map(carousel => {

            // Get for jQuery.
            let $carousel = $(carousel);

            /**
             *
             * @param 'perView' settings.
             * @link https://glidejs.com/docs/options/#perview
             *
             * These are set within each HTML template as data attributes.
             *
             * Defaults are set below should those not be set in the HTML markup.
             *
             */

            // Small <= 768px
            let perViewSmall = (typeof $carousel.data('per-view-small') !== 'undefined') ? $carousel.data('per-view-small') : 1;

            // Medium  <= 1280px
            let perViewMedium = (typeof $carousel.data('per-view-medium') !== 'undefined') ? $carousel.data('per-view-medium') : 3;

            // Large <= 1600px
            let perViewLarge = (typeof $carousel.data('per-view-large') !== 'undefined') ? $carousel.data('per-view-large') : 4;

            // XLarge >= 1600px
            let perViewXLarge = (typeof $carousel.data('per-view-xlarge') !== 'undefined') ? $carousel.data('per-view-xlarge') : 6;

            /**
             *
             * @param 'gap' settings.
             * @link https://glidejs.com/docs/options/#gap
             *
             * These are set within each HTML template as data attributes.
             *
             * Defaults are set below should those not be set in the HTML markup.
             *
             * * @note The gap is halfed for mobiles.
             *
             */
            let gap = (typeof $carousel.data('gap') !== 'undefined') ? $carousel.data('gap') : 30;
console.log(gap)
            /**
             *
             * @param 'peek' settings.
             * @link https://glidejs.com/docs/options/#peek
             *
             * This set within each HTML template as data attributes.
             * Defaults are set below should those not be set in the HTML markup.
             *
             */

            // Before
            let peekBefore = (typeof $carousel.data('peek-before') !== 'undefined') ? $carousel.data('peek-before') : 0;
            // After
            let peekAfter = (typeof $carousel.data('peek-after') !== 'undefined') ? $carousel.data('peek-after') : 100;

            /**
             *
             * @param 'startAt' settings.
             * @link https://glidejs.com/docs/options/#startat
             *
             * These are set within each HTML template as data attributes.
             * Defaults are set below should those not be set in the HTML markup.
             *
             */

            // Start
            let startAt = (typeof $carousel.data('start-at') !== 'undefined') ? $carousel.data('start-at') : 0;

            // Define the options
            options = {
                gap: (windowWidth > 768) ? gap : Math.round((gap/2)),
                perView: perViewXLarge,
                startAt: startAt,
                rewind: true,
                type: 'carousel',
                autoplay: 5000,
                breakpoints: {
                    460: {
                        perView: 1,
                    },
                    768: {
                        perView: perViewSmall
                    },
                    1280: {
                        perView: perViewMedium
                    },
                    1600: {
                        perView: perViewLarge
                    }
                },
                peek: {
                    before: (windowWidth > 768) ? peekBefore : Math.round((peekBefore/2)),
                    after: (windowWidth > 768 ? peekAfter : Math.round((peekAfter/2)))
                }
            }

            glide = new Glide(carousel, options)

            // Bug fix: Blurry text due to GlideJS not rounding the translate3d value to a whole numbnr.
            // @link https://github.com/glidejs/glide/issues/325
            glide.on(['mount', 'mount.after', 'run', 'resize'], function() {

                setTimeout(() => {
                    const currentCarousel = $(glide.selector).find('.glide__slides')[0]
                    currentCarousel.style.transform = 'translate3d(' + Math.round(currentCarousel.style.transform.substring(currentCarousel.style.transform.indexOf('(') + 1, currentCarousel.style.transform.indexOf('px'))) + 'px, 0px, 0px) translateZ(0)';
                }, 1);

            });


            let $control = $carousel.closest('.collection-carousel').find('[data-glide-dir]')
            if ($control.length > 0) {
                $control.on('click', function(event) {
                    event.preventDefault()
                    glide.go($(this).data('glide-dir'))
                })
            }

            glide.mount()

        });

    }

}

// Init.
SureifyCarousel('.glide-product-carousel')
SureifyHeroSlider()
SureifyProductSlider()

// Expose to other areas
window.SureifyCarousel = SureifyCarousel
window.SureifyProductOptions = SureifyProductOptions

// Detect reload for Shopify area.
if (Shopify.designMode) {

    document.addEventListener('shopify:section:load', function(){
        SureifyCarousel('.glide-product-carousel')
        SureifyHeroSlider()
        SureifyProductSlider()
    })

}